// extracted by mini-css-extract-plugin
module.exports = {"candidateIds":"styles_candidateIds__3wZZf"};